/**
 * Narrows a runtime string (a status, a source type from the backend) to a key of the catalog node `t` was
 * created for, when that node has it. `Key` names the node's keys, e.g.
 * `keyof EnglishMessages['consultantReceivables']['status']`; the `has` check is what makes the claim true.
 */
export function hasMessageKey<Key extends string>(t: { has(key: string): boolean }, value: string): value is Key {
  return t.has(value);
}
